import script from "./ViewBusiness.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBusiness.vue?vue&type=script&setup=true&lang=js"

import "./ViewBusiness.vue?vue&type=style&index=0&id=df667146&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df667146"]])

export default __exports__